import ListSpecialty from '@components/Specialty/ListSpecialty';
import SlideSpecialty from '@components/Specialty/SlideSpecialty';
import SpecialtyNav from '@components/Specialty/SpecialtyNav';
import {NextSeo} from 'next-seo';
import DepartmentService from '@services/department.service';
import {generateSpecialtyListSEO} from '@helper/seo/generators/specialty';

/**
 * Trang danh sách chuyên khoa
 * Hiển thị danh sách các chuyên khoa
 */
export default function SpecialtyHome(props) {
    const {seoPage} = props;
    
    return (
        <>
            {seoPage && <NextSeo {...seoPage} />}
            <div>
            {/* Hero section với banner */}
            <SlideSpecialty />
            
            {/* Navigation menu */}
            <SpecialtyNav />
            
            {/* Danh sách chuyên khoa */}
            <ListSpecialty />
        </div>
        </>
    );
}

SpecialtyHome.PageName = 'SPECIALTY';

SpecialtyHome.getInitialProps = async (context) => {
    try {
        const ctx = context || {};
        const webUrl = process.env.NEXT_PUBLIC_WEB_URL || process.env.WEB_URL || 'https://tnh.com.vn';
        
        // Fetch data thực tế từ API
        let departments = [];
        try {
            const departmentService = new DepartmentService(ctx);
            const departmentsResponse = await departmentService.getDepartmentList({
                locale: ctx.locale || 'vn'
            });
            
            // Xử lý response structure
            if (departmentsResponse) {
                if (Array.isArray(departmentsResponse)) {
                    departments = departmentsResponse;
                } else if (departmentsResponse.data && Array.isArray(departmentsResponse.data)) {
                    departments = departmentsResponse.data;
                } else if (departmentsResponse.items && Array.isArray(departmentsResponse.items)) {
                    departments = departmentsResponse.items;
                }
            }
        } catch (err) {
            console.error('Failed to fetch departments data for SEO:', err);
        }
        
        // Tạo SEO từ data thực tế
        const seoPage = generateSpecialtyListSEO(departments, webUrl);
        
        return {seoPage};
    } catch (error) {
        console.error('Failed to fetch SEO for specialty page:', error);
        const webUrl = process.env.NEXT_PUBLIC_WEB_URL || process.env.WEB_URL || 'https://tnh.com.vn';
        // Fallback SEO
        const seoPage = generateSpecialtyListSEO([], webUrl);
        return {seoPage};
    }
};
